// A declarative interval hook based on Dan Abramov's article (https://overreacted.io/making-setinterval-declarative-with-react-hooks).
// The interval can be paused by setting the delay to `null`.

import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, delay?: number | null) => {
  const savedCallback = useRef<() => void>(() => undefined);

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (delay !== null) {
      const interval = setInterval(() => savedCallback.current(), delay || 0);

      return () => clearInterval(interval);
    }

    return undefined;
  }, [delay]);
};
